export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
